import { createSelector } from '@ngrx/store';
import { getCheckoutFeatureState, ICheckoutFeatureState } from '../../reducers';
import { IBookingSummaryState } from '../../reducers/booking-summary';

export const selectBookingSummaryState = createSelector(
  getCheckoutFeatureState,
  (state: ICheckoutFeatureState) => state?.bookingSummary
);

export const selectSavedBookingSummary = createSelector(
  selectBookingSummaryState,
  (state: IBookingSummaryState | undefined) => state?.bookingSummary
);
